// 个人中心
import avatar from './images/avatar.png'

export default {
  avatar
}



// WEBPACK FOOTER //
// ./src/assets/imagesUrl.js